import moment from 'moment'

export class AllFilter {
  constructor () {
    this.id = 'all'
  }

  getFromToDate () {
    return {
      fromDate: null,
      toDate: null
    }
  }
}

export class HourOffsetFilter {
  constructor (offset) {
    this.type = 'HOUR'
    this.offset = offset || 0
    this.id = `${this.offset}_${this.type}`
  }

  getFromToDate () {
    const startTime = moment()
    const fromDate = startTime.clone()
    // Finally converting to ISOString
    const toDate = startTime.clone().add(this.offset, 'hours')

    return {
      fromDate: (fromDate.unix() * 1000),
      toDate: (toDate.unix() * 1000)
    }
  }
}

export class OneDayOffsetFilter {
  constructor (offset) {
    this.type = 'ONE_DAY'
    this.offset = offset || 0
    this.id = `${this.offset}_${this.type}`

    const startTime = moment()

    this.fromDate = startTime.clone()
      .startOf('day')
      .add(this.offset, 'day')
    // Finally converting to ISOString
    this.toDate = startTime.endOf('day')
      .add(this.offset, 'day')
  }

  getFromToDate () {
    return {
      fromDate: (this.fromDate.unix() * 1000),
      toDate: (this.toDate.unix() * 1000)
    }
  }
}

/*
* Racing Date Helpers
*/
const dateToISO = (date) => {
  const padZero = (n) => {
    return n < 10 ? '0' + String(n) : String(n)
  }
  return date.getFullYear() + '-' + padZero(date.getMonth() + 1) + '-' + padZero(date.getDate())
}

const dateKeyFromMs = (ms) => {
  return dateToISO(new Date(ms))
}

const dateFromDateKey = (dateKey) => {
  let dt = null
  try {
    // dateKey format: 2023-02-21
    dt = dateKey != null
      ? new Date(dateKey)
      : null
  } catch (e) {
    dt = null
  }
  return dt
}

const todayDateKey = () => {
  return dateToISO(new Date())
}

const futureDateKey = (days = 1) => {
  const dt = new Date()
  dt.setDate(dt.getDate() + days)
  return dateToISO(dt)
}

export const DateUtils = {
  dateToISO,
  dateKeyFromMs,
  dateFromDateKey,
  todayDateKey,
  futureDateKey
}
